module.exports = __webpack_public_path__ + "img/oaFlowData172@3x.852c337e.png";